import { render, staticRenderFns } from "./CustomPages.vue?vue&type=template&id=2b68577e&"
import script from "./CustomPages.vue?vue&type=script&lang=js&"
export * from "./CustomPages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports